export const SinSeleccion = () => {
  return (
    <>
      <div className='h-650px d-flex flex-center flex-column'>
        <div className='fw-bold fs-1'>Selecciona una opción</div>
        <div>
          <i className='fa-solid fa-filter text-gray-900 fs-3x'></i>
        </div>
      </div>
    </>
  )
}
